var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-fixed visible",attrs:{"id":"js-spinner"}},[_c('div',{staticClass:"sk-folding-cube"},[_c('div',{staticClass:"sk-cube1 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube2 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube4 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube3 sk-cube"})])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/global/Loader.vue